import { Helmet } from "react-helmet-async";
import { resolveMedia } from "@/lib/api";

const CANONICAL_BASE = "https://www.loveformankindhhc.com";

export default function Seo({ title, description, path = "/", image, type = "website", noindex = false, jsonLd, favicon }) {
  const canonical = CANONICAL_BASE + (path === "/" ? "" : path);
  const ogImage = image ? resolveMedia(image) : undefined;
  const blocks = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}
      {favicon && <link rel="icon" type="image/png" href={resolveMedia(favicon)} />}

      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:site_name" content="Love For Mankind" />
      {ogImage && <meta property="og:image" content={ogImage} />}

      <meta name="twitter:card" content={ogImage ? "summary_large_image" : "summary"} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {ogImage && <meta name="twitter:image" content={ogImage} />}

      {blocks.map((b) => {
        const json = JSON.stringify(b);
        return <script key={json} type="application/ld+json">{json}</script>;
      })}
    </Helmet>
  );
}
